import React from "react";
import ReactDOM from "react-dom";

// Source
import * as HelperSrc from "../HelperSrc";
import * as ModelCustomPreference from "../model/custom/Preference";
import * as ModelSetting from "../model/Setting";
import * as ModelRoute from "../model/Route";
import * as ModelRole from "../model/Role";
import * as ModelLocalization from "../model/Localization";
import * as ApiSetting from "../api/Setting";
import * as ApiRoute from "../api/Route";
import * as ApiRole from "../api/Role";
import * as ApiLocalization from "../api/Localization";
import StorePreference from "../store/Preference";
import StoreSetting from "../store/Setting";
import StoreRoute from "../store/Route";
import StoreRole from "../store/Role";
import StoreLocalization from "../store/Localization";
import ControllerAlert from "../controller/Alert";
import ViewAlert from "../view/Alert";
import ViewRoute from "../view/Route";

HelperSrc.disableConsoleMessage('Warning: Each child in a list should have a unique "key" prop.');

let isRendered = false;

const App: React.FC = () => {
    // Variable
    const storePreference = new StorePreference();
    const storagePreferenceData = storePreference.storageGet() as ModelCustomPreference.Idata;
    const storeSetting = new StoreSetting();
    const storeRoute = new StoreRoute();
    const storeRole = new StoreRole();
    const storeLocalization = new StoreLocalization();

    const controllerAlert = new ControllerAlert(isRendered);

    const [getApiLoadingList, setApiLoadingList] = React.useState<Record<string, boolean>>({});

    // Method
    React.useEffect(() => {
        if (!storagePreferenceData) {
            const preference = {
                country: "jp",
                language: "ja",
                sidebar: false,
                isShowPreviewDraftDialog: true,
                isAutoSaveDraft: true
            } as ModelCustomPreference.Idata;

            storePreference.storageSet(preference);
        }

        const path = window.location.pathname.replace(`/${HelperSrc.LABEL}`, "");
        if (path === "" || path === "/" || path === "/login") {
            const apiWrapPromiseList: Promise<void>[] = [
                HelperSrc.apiWrapPromise(
                    ApiSetting.dataList,
                    (data) => storeSetting.storageSet(data as unknown as ModelSetting.Idata),
                    controllerAlert
                ),
                HelperSrc.apiWrapPromise(ApiRoute.dataList, (data) => storeRoute.storageSet(data as unknown as ModelRoute.Idata), controllerAlert),
                HelperSrc.apiWrapPromise(ApiRole.dataList, (data) => storeRole.storageSet(data as unknown as ModelRole.Idata), controllerAlert),
                HelperSrc.apiWrapPromise(
                    ApiLocalization.dataList,
                    (data) => storeLocalization.storageSet(data as unknown as ModelLocalization.Idata),
                    controllerAlert
                )
            ];

            Promise.all(apiWrapPromiseList)
                .then(() => {
                    setApiLoadingList({ all: true });
                })
                .catch(() => {
                    setApiLoadingList({ all: true });
                });
        } else {
            setApiLoadingList({ all: true });
        }
    }, []);

    // Render
    isRendered = true;

    return (
        <div>
            {(() => {
                const html: JSX.Element[] = [];

                if (getApiLoadingList.all) {
                    const htmlElement = document.querySelector<HTMLElement>("html");
                    const bodyElement = document.querySelector<HTMLElement>("body");

                    if (htmlElement && storagePreferenceData) {
                        htmlElement.setAttribute("lang", storagePreferenceData.language);
                    }

                    if (bodyElement && storagePreferenceData) {
                        const oldClass = bodyElement.classList[0];

                        if (bodyElement.classList.contains(oldClass)) {
                            bodyElement.classList.replace(oldClass, storagePreferenceData.language);
                        } else {
                            bodyElement.classList.add(storagePreferenceData.language);
                        }
                    }

                    html.push(
                        <div>
                            <ViewAlert />
                            <ViewRoute />
                        </div>
                    );
                }

                return html;
            })()}
        </div>
    );
};

ReactDOM.render(<App />, document.getElementById("app"));
